import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const Datatables = ({data, onFetchAbsensi }) => {
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleSubmit = (e) => {
      e.preventDefault();
      onFetchAbsensi();
    };


    const formattedData = data.map((item, index) => ({
      id: index + 1,
      ...item
    }));

    const filteredData = formattedData.filter((item) =>
      [item?.KARYAWAN_ID, item?.NAMA_LENGKAP]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );

    const columns = [
      { name: "No", selector: (row) => row.id, minWidth: '10px', style: { display: "flex", justifyContent: "center", alignItems: "center" } },
      { name: "Date", selector: (row) => row.Date, minWidth: "100px", sortable: true },
      { name: "Duty In", selector: (row) => row.duty_in, minWidth: "120px", sortable: true },
      { name: "Time In", selector: (row) => row.time_in, minWidth: "80px", sortable: true },
      { name: "Duty Out", selector: (row) => row.duty_out, minWidth: "80px", sortable: true },
      { name: "Time Out", selector: (row) => row.time_out, minWidth: "80px", sortable: true },
      { name: "Status", selector: (row) => row.status, minWidth: "80px", sortable: true },
      { name: "Uang Makan", selector: (row) => row.um, minWidth: "80px", sortable: true },
      { name: "Jumlah", selector: (row) => row.jumlah, minWidth: "80px", sortable: true },
    ];

    const customStylesOverride = {
      ...DatatableStyles,
      headCells: {
        ...DatatableStyles.headCells,
        style: {
          ...DatatableStyles.headCells.style,
          fontSize: "12px",
        },
      },
      cells: {
        ...DatatableStyles.cells,
        style: {
          ...DatatableStyles.cells.style,
          fontSize: "12px",
        },
      },
    };

  return (
    <div class="row">
      <div className="col-lg-12 m-4">
        <form onSubmit={handleSubmit}>
          <div className="row mb-1 align-items-center">
            <label className="col-sm-2 form-label">Dari Tanggal</label>
            <div className="col-sm-3">
                <div className="input-group">
                    <span className="input-group-text">
                        <i className="bx bx-calendar"></i>
                    </span>
                    <Flatpickr
                        className="form-control form-control-sm "
                        value={startDate}
                        options={{
                        dateFormat: "Y-m-d",
                        // minDate: "today", // hanya bisa pilih mulai hari ini
                        }}
                        onChange={([date]) => {
                        setStartDate(date);
                        setEndDate(null); // reset endDate saat startDate berubah
                        }}
                    />
                </div>
            </div>
            <label className="col-sm-1 form-label text-center">s/d</label>
            <div className="col-sm-3">
                <div className="input-group">
                    <span className="input-group-text">
                        <i className="bx bx-calendar"></i>
                    </span>
                    <Flatpickr
                        className="form-control form-control-sm "
                        value={endDate}
                        options={{
                        dateFormat: "Y-m-d",
                        minDate: startDate || "today", // tidak bisa sebelum startDate
                        }}
                        onChange={([date]) => setEndDate(date)}
                        disabled={!startDate} // tidak bisa diklik sebelum startDate diisi
                    />
                </div>
            </div>
            <div className="col-sm-2">
              <button type="submit" className="btn btn-sm btn-success">Show</button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
          <input
          type="text"
          placeholder="Search..."
          class="form-control w-100"
          style={{ maxWidth: "200px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={customStylesOverride}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
      </div>
    </div>
  );
};

export default Datatables;
